export interface RenderedMessageTemplate {
  message: string;
  properties: Record<string, unknown>;
}

const TOKEN = /\{\{|\}\}|\{([A-Za-z_][A-Za-z0-9_]*)\}/g;

/** Serilog-style: `{Name}` placeholders bind positional args and become named properties; `{{`/`}}` escape braces. */
export function renderMessageTemplate(template: string, args: readonly unknown[] = []): RenderedMessageTemplate {
  const properties: Record<string, unknown> = {};
  let nextArg = 0;

  const message = template.replace(TOKEN, (token: string, name: string | undefined) => {
    if (!name) {
      return token[0];
    }
    if (!(name in properties)) {
      if (nextArg >= args.length) {
        return token;
      }
      properties[name] = args[nextArg++];
    }
    return formatValue(properties[name]);
  });

  return { message, properties };
}

function formatValue(value: unknown): string {
  if (typeof value === 'string') {
    return value;
  }
  if (value instanceof Error) {
    return value.message;
  }
  if (value !== null && typeof value === 'object') {
    try {
      return JSON.stringify(value);
    } catch {
      return String(value);
    }
  }
  return String(value);
}
